import { render, staticRenderFns } from "./verbaleTaraturaValvole.vue?vue&type=template&id=6641ea3e"
import script from "./verbaleTaraturaValvole.vue?vue&type=script&lang=js"
export * from "./verbaleTaraturaValvole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports